// @ts-ignore
 
import request from "src/lib/axios";

/** C 端获取分期套餐详情 用户进入分期预览页，携带分期套餐 ID 获取套餐详情及各期账单预览 GET /api/v1/app/sku-installments/${param0} */
export async function AppSkuInstallmentControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppSkuInstallmentControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputClientProductSkuInstallmentDetailDto>(
    `/api/v1/app/sku-installments/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}
